import './styles/styles.css';
import './styles/sidebar.css';
import './styles/streamers.css';
import './styles/chat.css';
import './styles/global-chat.css';
import './styles/players.css';
import './styles/options.css';
import './styles/welcome-screen.css';

import { initializeI18n } from './services/i18n';
import { initializeTooltips } from './services/tooltips';
import './app/app';

initializeI18n();
initializeTooltips();
